import React, { useState, useRef, useEffect } from "react";
import "../../styles/CustomControls.css";

const CustomDropdown = ({
  label,
  value = "",
  options = [],
  onChange,
  placeholder = "Select",
  optionValue = "id",
  optionLabel = "name",
  className = "",
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getVal = (opt) => (typeof opt === "object" ? opt[optionValue] : opt);
  const getLabel = (opt) => (typeof opt === "object" ? opt[optionLabel] : opt);

  // Always add "All" as the first option
  const dropdownOptions = [
    { [optionValue]: "", [optionLabel]: "All" },
    ...options,
  ];

  const selected = dropdownOptions.find(
    (opt) => String(getVal(opt)) === String(value),
  );
  const displayLabel = selected ? getLabel(selected) : placeholder;

  return (
    <div className={`rbFilterField ${className}`} ref={ref}>
      {label && <label>{label}</label>}

      <div className="rbCustomSelect">
        <button
          type="button"
          className="rbCustomSelectTrigger"
          onClick={() => !disabled && setOpen((o) => !o)}
          disabled={disabled}
        >
          <span>{displayLabel}</span>
        </button>

        {open && (
          <ul className="rbCustomSelectOptions">
            {dropdownOptions.length > 0 ? (
              dropdownOptions.map((option, index) => {
                const val = getVal(option);
                const lbl = getLabel(option);

                return (
                  <li
                    key={val || `all-${index}`}
                    className={String(val) === String(value) ? "active" : ""}
                    title={lbl}
                    onClick={() => {
                      onChange(val);
                      setOpen(false);
                    }}
                  >
                    {lbl}
                  </li>
                );
              })
            ) : (
              <li className="no-options">No options available</li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CustomDropdown;
